export default __webpack_public_path__ + "static/media/Punto_11_Palazzi_dell_800_FRA_Def.8f2dcfe3.aac";